// Testimonials — progressive enhancement
// The block ships a plain, readable <ul class="testimonials-list"> of quotes. Here we
// move those <li>s into a Splide scaffold and mount a slider. No JS (or no Splide) →
// the stacked list stays exactly as it is, every quote readable.
//
// Splide's `autoHeight` only works for vertical sliders, so a horizontal track just
// grows to the *tallest* quote — the old site's problem (huge dead space under the
// short quotes). Instead we size the track to the active quote ourselves and let CSS
// transition the height. No autoplay, so the section reflowing on navigation is fine.
ready(function () {
    if (typeof Splide === 'undefined')
        return;

    findAll('.contentblock-testimonials[data-testimonials-slider]').forEach(function (block) {
        const list = block.find('.testimonials-list');
        if (!list)
            return;

        const items = Array.from(list.children);
        if (items.length < 2)
            return; // a single quote needs no slider

        // Build the Splide scaffold and move the existing <li>s into it, so the markup
        // stays semantic and nothing is duplicated.
        const splide = create(
            '<div class="splide">' +
                '<div class="splide__track">' +
                    '<ul class="splide__list"></ul>' +
                '</div>' +
            '</div>'
        );
        const splideList = splide.find('.splide__list');
        items.forEach(function (item) {
            item.classList.add('splide__slide');
            splideList.appendChild(item);
        });

        list.replaceWith(splide);

        const slider = new Splide(splide, {
            type: 'loop',
            arrows: false,
            pagination: true,
            speed: 500,
            keyboard: 'focused',
            i18n: {
                slideLabel: 'Kundenstimme %s von %s'
            }
        });

        const track = splide.find('.splide__track');

        const heightOf = (el) => (el ? Math.ceil(el.getBoundingClientRect().height) : 0);
        const fitTo = (el) => { if (el) track.style.height = heightOf(el) + 'px'; };
        const fitActive = () => fitTo(splide.find('.splide__list > .is-active'));

        // Grow/shrink to the destination quote as the move starts, so the height
        // animates in step with the slide.
        slider.on('move', function (newIndex) {
            const slide = slider.Components.Slides.getAt(newIndex);
            if (slide) fitTo(slide.slide);
        });
        slider.on('resized', fitActive);
        slider.on('mounted', function () {
            // Set the first height without a transition so it doesn't jump on load.
            track.style.transition = 'none';
            fitActive();
            requestAnimationFrame(function () {
                track.style.transition = '';
                fitActive();
            });
        });

        slider.mount();
    });
});
